import React from "react";
import { FaGithub, FaLinkedin, FaInstagram } from "react-icons/fa";
import { NavLink } from "react-router-dom";
import { HiOutlineMail } from "react-icons/hi";
import { BsFillPersonLinesFill } from "react-icons/bs";
const MobileNav = ({ handleChange, getresume, navs }) => {
  return (
    <>
      <ul
        aria-label="link list"
        className="absolute top-0 left-0 flex flex-col items-center justify-center w-full min-h-screen overflow-hidden md:hidden bg-gray-900/95 backdrop-blur-2xl"
      >
        {navs.map((nav) => (
          <li
            onClick={handleChange}
            key={nav.id}
            aria-label={nav.name}
            className="py-4 text-4xl outline-transparent focus:bg-transparent"
          >
            <NavLink
              className={({ isActive }) =>
                isActive
                  ? "border-b-2 pb-1 border-cyan-600 text-teal-200 ease-in-out duration-300"
                  : undefined
              }
              to={nav.link}
            >
              {nav.name}
            </NavLink>
          </li>
        ))}

        <li
          aria-label="divider"
          className="w-10/12 border-[1px] border-gray-700"
        ></li>
        <li aria-label="social links" className="flex gap-4 py-6 text-3xl">
          <a
            href="https://www.Linkedin.com/in/itiwariarun"
            id="linkedin page-nav"
            rel="exteranl noreferrer noopener"
            title="linkedin page"
            target="_blank"
          >
            <FaLinkedin aria-label="Linkedin" />
          </a>
          <a
            href="https://www.instagram.com/itiwariarun/?igshid=YmMyMTA2M2Y%3D"
            id="instagram page-nav"
            rel="exteranl noreferrer noopener"
            title="instagram page"
            target="_blank"
          >
            <FaInstagram aria-label="instagram" />
          </a>
          <a
            href="https://www.github.com/itiwariarun"
            id="github page-nav"
            rel="exteranl noreferrer noopener"
            title="github page"
            target="_blank"
          >
            <FaGithub aria-label="github" />
          </a>
          <a href="mailto: itiwariarun438@gmail.com">
            <HiOutlineMail aria-label="mail" />
          </a>
          <button
            type="button"
            className="active:outline-none"
            onClick={getresume}
          >
            <BsFillPersonLinesFill aria-label="resume" />
          </button>
        </li>
      </ul>
    </>
  );
};

export default MobileNav;
